export default __webpack_public_path__ + "static/media/Shoe-1.8fa1b71e.mp4";